import React, { useMemo } from 'react';
import { View, TextInput, StyleSheet, TextInputProps } from 'react-native';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import { useTheme } from '../theme';
import { ThemeColors } from '../theme/types';

type Props = {
  placeholder?: string;
  value: string;
  onChangeText: (t: string) => void;
  editable?: boolean;
  trailingIcon?: string;
  style?: any;
  wrapperStyle?: any;
  disabledStyle?: any;
} & Partial<TextInputProps>;

const createStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    inputWrapper: {
      position: 'relative',
    },
    trailingIcon: {
      position: 'absolute',
      right: 8,
      top: 10,
    },
    input: {
      height: 42,
      borderWidth: 1,
      borderColor: colors.input.border,
      borderRadius: 4,
      paddingHorizontal: 8,
      backgroundColor: colors.input.background,
      color: colors.text.primary,
    },
    inputDisabled: {
      backgroundColor: colors.border.default,
      color: colors.text.secondary,
    },
  });

const LhTextInput: React.FC<Props> = ({
  placeholder,
  value,
  onChangeText,
  editable = true,
  trailingIcon,
  style,
  wrapperStyle,
  disabledStyle,
  ...rest
}) => {
  const { colors } = useTheme();
  const styles = useMemo(() => createStyles(colors), [colors]);

  return (
    <View style={[styles.inputWrapper, wrapperStyle]}>
      <TextInput
        style={[
          styles.input,
          style,
          !editable && (disabledStyle || styles.inputDisabled),
          trailingIcon ? { paddingRight: 28 } : undefined,
        ]}
        placeholder={placeholder}
        placeholderTextColor={colors.text.disabled}
        value={value}
        onChangeText={onChangeText}
        editable={editable}
        {...rest}
      />
      {trailingIcon ? (
        <View style={styles.trailingIcon} pointerEvents="none">
          <MaterialIcons name={trailingIcon} size={20} color={colors.text.secondary} />
        </View>
      ) : null}
    </View>
  );
};

export default LhTextInput;
